import { Component, OnDestroy, OnInit } from '@angular/core';
import * as EmployeeActions from './../../store/employee/employee.actions';
import { EmployeeState } from '../../store/employee/employee.reducer';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as fromEmployeeSelectors from '../../store/employee/employee.selectors';
import { Department, EmployeeJobCode, IEmployee } from '@signal/asp-data-commons';
import { unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-parts-personnel',
  templateUrl: './parts-personnel.component.html',
  styleUrls: ['./parts-personnel.component.scss']
})
export class PartsPersonnelComponent implements OnInit, OnDestroy {

  isLoading$!: Observable<boolean>;
  activeEmployees$!: Observable<IEmployee[]>;
  syncStatus$!: Observable<string | undefined>;
  lastSyncedAt$!: Observable<string | undefined>;
  isSyncStatusLoading$!: Observable<boolean>;
  refreshInterval: ReturnType<typeof setInterval> | undefined;
  subs: SubscriptionList = {};
  private isStaffMasterSyncInProgress = false;

  constructor(
    private readonly employeeStore: Store<EmployeeState>,
    private readonly alertService: AlertService
  ) {}

  ngOnInit() {
    this.setupStore();
  }

  private setupStore() {
    this.dispatchActions();

    this.isSyncStatusLoading$ = this.employeeStore.select(fromEmployeeSelectors.selectIsSyncStatusLoading);
    this.syncStatus$ = this.employeeStore.select(fromEmployeeSelectors.selectSyncStatus);
    this.subs.syncstatus = this.syncStatus$.subscribe(status => {
      if (status === 'SYNC_COMPLETED') {
        if (this.isStaffMasterSyncInProgress) {
          this.alertService.showAlert('otherTexts.syncedSuccessfully', '', '', 5000, false);
        }
        this.isStaffMasterSyncInProgress = false;
        clearInterval(this.refreshInterval);
      } else if (status === 'SYNC_FAILED') {
        this.isStaffMasterSyncInProgress = false;
        clearInterval(this.refreshInterval);
      }
    });
    this.lastSyncedAt$ = this.employeeStore.select(fromEmployeeSelectors.selectSyncStatusLastSyncedAt);
    this.isLoading$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesLoading);
    this.activeEmployees$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployees).pipe(
      map((employees: IEmployee[]) => employees.filter((e: IEmployee) => e.department === Department.PARTS
        && e.jobCode === EmployeeJobCode.ADVISOR
        && e.isActive))
    );
  }

  private dispatchActions() {
    this.employeeStore.dispatch(new EmployeeActions.LoadEmployees());
    this.employeeStore.dispatch(new EmployeeActions.LoadStaffMasterSyncStatus());
  }

  triggerStaffMasterSync() {
    this.isStaffMasterSyncInProgress = true;
    this.employeeStore.dispatch(new EmployeeActions.TriggerStaffMasterSync());
    this.refreshInterval = setInterval(() => {
      this.employeeStore.dispatch(new EmployeeActions.LoadStaffMasterSyncStatus());
    }, 10 * 1000);
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
}
